import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'designation'
})
export class DesignationPipe implements PipeTransform {

	transform(value: any, args?: any): string {
		return value ? value.designation : '';
	}

}
